export default  {
  require: {
    ngModel: 'ngModel'
  },
  controller: 'propertySingleSelectController',
  template: require('../views/property.single.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.single.select.component.js